module.exports = __webpack_public_path__ + "static/media/majorG3.bf0c63c.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/sing/majorG3.wav
// module id = yfCy
// module chunks = 0